import TemplateView from '../TemplateView';

export default class DisabledContainer extends TemplateView {
    constructor({$containerEl, contentComponent, containerClass}) {
        super($containerEl)

        this.state = {
            disabled: false
        }

        this.contentComponent = contentComponent
        this.containerClass = containerClass;

        this.onStatePropertyChanged("disabled", disabled => this.$el.toggleClass("disabled", disabled))
    }

    afterRender() {
        this.contentComponent.init(this.find(".content"));
        this.registerChildComponents(this.contentComponent)
    }

    templateHtml() {
        return "<div class='disabledContainer <%=containerClass%>'>" +
               "  <div class='content'></div>" +
               "  <div class='moire'></div>" +
               "</div>"
    }

    setState(stateChanges) {
        super.setState(stateChanges);
        this.applyForChildrenComponents(child => child.setState(stateChanges))
    }
}


// WEBPACK FOOTER //
// ./web/js/util/DisabledContainer.js